var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{staticStyle:{"background":"#fffbfe"},attrs:{"toggleable":"lg","type":"light"}},[_c('b-navbar-brand',[(!_vm.loading)?_c('b-form-select',{staticClass:"studySiteSelectorText",style:(_vm.width < 400 ? 'font-size: 14px' : 'font-size: 18px'),attrs:{"options":_vm.studySites},on:{"change":function($event){return _vm.switchStudySite($event)}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_c('b-spinner',{attrs:{"type":"grow","variant":"secondary"}})],1),_vm._v(" "),_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"},scopedSlots:_vm._u([{key:"default",fn:function({ expanded }){return [(expanded)?_c('b-icon',{attrs:{"icon":"chevron-bar-up"}}):_c('b-icon',{attrs:{"icon":"chevron-bar-down"}})]}}])}),_vm._v(" "),_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":""}},[_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{staticClass:"navigation-item",attrs:{"active":_vm.$route.name.includes('site-summary'),"to":{
            name: 'site-summary',
            params: {
              siteId: _vm.siteId,
              studyId: _vm.studyId,
            },
          },"active-class":"router-link-exact-active"}},[_vm._v("Summary\n        ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"navigation-item",attrs:{"active":_vm.$route.name.includes('site-enrollment'),"hidden":!_vm.canSeeEnrollment,"to":{
            name: _vm.enrollmentRoute,
            params: {
              siteId: _vm.siteId,
              studyId: _vm.studyId,
            },
          },"active-class":"router-link-exact-active"}},[_vm._v("Enrollment\n        ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"navigation-item",attrs:{"active":_vm.$route.name.includes('start-up-plan'),"hidden":!_vm.canSeeStartUpPlan,"to":{
            name: _vm.startUpPlanRoute,
            params: {
              siteId: _vm.siteId,
              studyId: _vm.studyId,
            },
          },"active-class":"router-link-exact-active"}},[_vm._v("Start-Up Plan\n        ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"navigation-item",attrs:{"active":_vm.$route.name.includes('application-access'),"hidden":!_vm.canSeeApplicationAccess,"to":{
            name: _vm.applicationAccessRoute,
            params: {
              siteId: _vm.siteId,
              studyId: _vm.studyId,
            },
            query: {
              option: 'my-access',
            },
          },"active-class":"router-link-exact-active"}},[_vm._v("Application Access\n        ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"navigation-item",attrs:{"active":_vm.$route.name.includes('study-site-milestones'),"hidden":!_vm.canSeeMilestones,"to":{
            name: _vm.milestoneRoute,
            params: {
              siteId: _vm.siteId,
              studyId: _vm.studyId,
            },
          },"active-class":"router-link-exact-active"}},[_vm._v("Milestones\n        ")]),_vm._v(" "),_c('b-nav-item',{staticClass:"navigation-item",attrs:{"active":_vm.$route.name.includes('system-outage-messages'),"hidden":!_vm.canSeeSystemOutageMessages,"to":{
            name: _vm.systemOutageMessagesRoute,
            query: {
              pagination: 'vue',
            },
          },"active-class":"router-link-exact-active"}},[_vm._v("System Outage Messages\n        ")]),_vm._v(" "),(_vm.allowStudySubject)?_c('b-nav-item',{staticClass:"navigation-item",attrs:{"active":_vm.$route.name.includes('study-subject'),"hidden":!_vm.haveSubjects,"to":{
            name: 'study-subject',
            params: {
              siteId: _vm.siteId,
              studyId: _vm.studyId,
            },
          },"active-class":"router-link-exact-active"}},[_vm._v("Substudy\n        ")]):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }